var map = {
	"./add-photo-fifth-icon.svg": "ccae",
	"./add-photo-first-icon.svg": "e41a",
	"./add-photo-fourth-icon.svg": "3b39",
	"./add-photo-second-icon.svg": "5725",
	"./add-photo-seventh-icon.svg": "78c7",
	"./add-photo-sixth-icon.svg": "0a36",
	"./add-photo-third-icon.svg": "45a5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9946";